import { render, staticRenderFns } from "./changePassForm.vue?vue&type=template&id=0d78ed54"
import script from "./changePassForm.vue?vue&type=script&lang=js"
export * from "./changePassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports